import script from "./Chapter8.vue?vue&type=script&setup=true&lang=js"
export * from "./Chapter8.vue?vue&type=script&setup=true&lang=js"

import "./Chapter8.vue?vue&type=style&index=0&id=6cdbf4bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cdbf4bc"]])

export default __exports__